import { apiInstance } from "redux/axiosApi";
import { ASSIGN_NUMBER, ASSIGN_USER, CHECK_COVER_PAGE, COVER_PAGE, DELETE_COVER_PAGE, NUMBER_LIST, USER_LIST } from "API/constAPI";

export const coverPagesGet = (params: any) => {
  return apiInstance.get(COVER_PAGE, { params });
};

export const coverPageCreate = (data: any) => {
  return apiInstance.post(COVER_PAGE, data);
};

export const coverPageDelete = (id: number) => {
  return apiInstance.delete(DELETE_COVER_PAGE(id));
};

export const coverPageAssignUserUpdate = (coverpage_id: number, user_id: number) => {
  return apiInstance.put(ASSIGN_USER(coverpage_id, user_id));
};

export const coverPageAssignNumberUpdate = (coverpage_id: number, number_id: number) => {
  return apiInstance.put(ASSIGN_NUMBER(coverpage_id, number_id));
};

export const coverPageAssignedUserDelete = (coverpage_id: number, user_id: number) => {
  return apiInstance.delete(ASSIGN_USER(coverpage_id, user_id));
};

export const coverPageAssignedNumberDelete = (coverpage_id: number, number_id: number) => {
  return apiInstance.delete(ASSIGN_NUMBER(coverpage_id, number_id));
};

export const numberListGet = () => {
  return apiInstance.get(NUMBER_LIST);
};

export const userListGet = () => {
  return apiInstance.get(USER_LIST);
};

export const coverPageCheck = (user_id: number, number_id: number) => {
  return apiInstance.get(CHECK_COVER_PAGE(user_id, number_id));
};